<script>
  import Page from 'page'
  export let title
  import { api } from '../../store'
  let localapi
  api.subscribe((value) => {
    localapi = value
  })

  // let checkLocalStorage = localStorage.getItem('loginData')
  // console.log(checkLocalStorage)
  // if (checkLocalStorage.email) {
  //   Page.redirect('/members')
  // }

  let email
  let password
  let result

  if (JSON.parse(localStorage.getItem('loginData')) !== null) {
    Page.redirect('/members')
  }

  function validateForm() {
    let allValue = { login: true, email, password }
    let error = ''

    for (const [key, value] of Object.entries(allValue)) {
      if (value === undefined) {
        error += `${key} \n`
      }
    }
    error == '' ? senddata(allValue) : console.log(error)
  }

  async function senddata(param) {
    // let res = await fetch('https://reqres.in/api/login',

    let data = new FormData()
    data.append('login', true)
    data.append('email', param.email)
    data.append('password', param.password)

    let xhttp = new XMLHttpRequest()

    // xhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded')
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4 && this.status == 200) {
        // Typical action to be performed when the document is ready:
        result = JSON.parse(xhttp.responseText)
        console.log(result)

        if (!result.error) {
          localStorage.setItem('loginData', JSON.stringify(result))
          // Page.redirect('/members')
          window.location.reload()
        } else {
          Page.redirect('/')
        }
      }
    }
    xhttp.open('POST', `${localapi}login.php`, true)
    xhttp.send(data)
  }
</script>

<svelte:head>
  <title>
    {title} - Devanga Sowdeshwari Amman Association of North America (DSAANA)
  </title>
</svelte:head>
<div class="login">
  <form on:submit|preventDefault="{validateForm}">
    <div>
      <h2 class="text-center">Member Login Portal</h2>
    </div>
    <div class="form-group">
      <label for="exampleInputEmail1">Email address</label>
      <input
        bind:value="{email}"
        type="email"
        class="form-control"
        aria-describedby="emailHelp"
        placeholder="Enter email" />
      <small id="emailHelp" class="form-text text-muted">
        We'll never share your email with anyone else.
      </small>
    </div>
    <div class="form-group">
      <label for="exampleInputPassword1">Password</label>
      <input
        bind:value="{password}"
        type="password"
        class="form-control"
        placeholder="Password" />
    </div>
    <br />
    <button type="submit" class="btn btn-primary">Submit</button>
    <p>or</p>
    <a href="/signup">Sign Up</a>
  </form>
</div>

<style lang="scss">
  .login {
    min-height: 80vh;
    display: flex;
    justify-content: center;
    align-items: center;

    form {
      width: 100%;
      max-width: 380px;
    }
  }
</style>
